import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UpdatesService {

    public isUpdatesOpen: boolean
    public isUpdatesOpen$: BehaviorSubject<boolean>;

    constructor(
        private http: HttpClient,
    ) {
        this.isUpdatesOpen = false
        this.isUpdatesOpen$ = new BehaviorSubject(false);
    }

    openUpdates() {
        this.isUpdatesOpen = true
        console.log("Updates open")
        this.isUpdatesOpen$.next(this.isUpdatesOpen)
    }

    closeUpdates() {
        this.isUpdatesOpen = false
        console.log("Updates close")
        this.isUpdatesOpen$.next(this.isUpdatesOpen)
    }

    toggleUpdates() {
        this.isUpdatesOpen = !this.isUpdatesOpen
        this.isUpdatesOpen$.next(this.isUpdatesOpen)
    }

    sendSubscribe(email: string): Promise<string> {

        let promise = new Promise<string>((resolve, reject) => {
            var obj = {
                imported_on: "",
                media_type: "movie",
                source: "MovieSpherePlus",
                title: "MovieSpherePlus",
                email: email.toLowerCase(),
                source_url: window.location.href
            };

            this.http.post<any>('https://lionsgatevip.com/subscriber/subscribe', obj).subscribe(data => {
                console.log("response:", data);
                if (data.status == 'success') {
                    resolve('Subscribed');
                }
                else {
                    resolve('Error: Please try again later.')
                }
            })
        })

        return promise
    }
}